import Block from './component';

export default Block;
